export const listPosition = state => {
  let temp = state.listPosition
  let data = []
  let roles = [1]

  if (Array.isArray(temp) && temp.length) {
    temp.forEach(element => {
      if (!roles.includes(element.id))
        data.push({
          id: element.id,
          label: element.name,
          position: element.position ? element.position.name : '-'
        })
    })
  }

  return data
}

export const positionOptions = state => {
  let temp = state.listPosition
  let data = []
  let roles = [1, 2]

  if (Array.isArray(temp) && temp.length) {
    temp.forEach(element => {
      if (!roles.includes(element.id))
        data.push({
          id: element.id,
          label: element.name
        })
    })
  }

  return data
}

export const listDivision = state => {
  let temp = state.divisions
  let temps = []

  if (Array.isArray(temp) && temp.length)
    temp.forEach(t => {
      temps.push({
        id: t.id,
        label: t.name
      })
    })

  return temps
}
